import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-5318825a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "d-flex align-items-center justify-content-between"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "fs-24 fw-4 color-white"
  }, "韶关污水泵站运维管理平台")], -1);
});
var _hoisted_2 = {
  class: "d-flex align-items-center justify-content-between"
};
var _hoisted_3 = {
  class: "d-flex align-items-center mr-4"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", null, "报警通知", -1);
});
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { ElLoading, ElMessage, ElNotification } from "element-plus";
import { logoutAPI } from "@/api/auth";
import { removeToken } from "../../src/utils/auth";
import { Bell, MuteNotification } from '@element-plus/icons-vue';
import settings from "@/settings";
import { storage } from "@utils/storage";
import { getMenuList } from "@typings/menuList";
import MenuItem from "@views/layout/MenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup: function (__props) {
    var store = useStore();
    var router = useRouter();
    var route = useRoute();
    var userInfo = computed(function () {
      return store.getters['app/userInfo'];
    });
    // region TODO 登出
    function logout() {
      var loading = ElLoading.service({
        text: '正在安全退出'
      });
      logoutAPI().then(function (res) {
        res.result().then(function () {
          removeToken();
          ElMessage.success('已安全登出');
          router.push({
            name: 'Login'
          });
        });
      }).finally(loading.close);
    }
    // endregion
    var menuList = ref([]);
    onMounted(function () {
      menuList.value = getMenuList();
      defaultActive.value = route.path;
      soundStatus.value = storage.local.get('soundStatue') || false;
      ssu = new SpeechSynthesisUtterance();
      ssu.voice = window.speechSynthesis.getVoices().filter(function (voice) {
        return voice.localService === true && voice.lang === 'zh-CN';
      })[0];
      ssu.lang = 'zh-ch';
      ssu.rate = 1;
      activeMenu(route);
      loadWebSocket();
      console.log(menuList.value);
    });
    // region TODO 监听选中菜单
    var defaultActive = ref('');
    onBeforeRouteUpdate(function (e) {
      activeMenu(e);
    });
    function activeMenu(route) {
      defaultActive.value = (route === null || route === void 0 ? void 0 : route.meta.activeMenu) || route.path;
    }
    // endregion
    var soundStatus = ref(false);
    function turnOffSound() {
      soundStatus.value = false;
      storage.local.set('soundStatue', false);
    }
    function openSound() {
      soundStatus.value = true;
      storage.local.set('soundStatue', true);
    }
    var wsUrl = ref("".concat(settings.WEBSOCKET, "/").concat(userInfo.value.id));
    var ws = null;
    function loadWebSocket() {
      ws && ws.close();
      ws = new WebSocket(wsUrl.value);
      ws.onopen = function () {
        console.log('连接成功 webSocket');
        ws.send('给我消息');
      };
      ws.onmessage = function (e) {
        console.log(e);
        var abc = e.data;
        var aaa = JSON.parse(abc);
        console.log(aaa);
        if (aaa.alarmLevel && soundStatus.value) {
          ElNotification({
            type: 'warning',
            title: "".concat(aaa.alarmLevel),
            zIndex: 999,
            showClose: true,
            duration: 5000,
            message: "".concat(aaa.alarmMessage)
          });
          var alarmData = "".concat(aaa.alarmLevel, " , ").concat(aaa.alarmMessage);
          voiceBroadcast(alarmData);
        } else if (aaa.alarmLevel) {
          ElNotification({
            type: 'warning',
            title: "".concat(aaa.alarmLevel),
            zIndex: 999,
            showClose: true,
            duration: 5000,
            message: "".concat(aaa.alarmMessage)
          });
        }
      };
    }
    var ssu;
    function voiceBroadcast(e) {
      ssu.text = e;
      speechSynthesis.speak(ssu);
    }
    onUnmounted(function () {
      ws.close();
    });
    return function (_ctx, _cache) {
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_link = _resolveComponent("el-link");
      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      var _component_el_dropdown = _resolveComponent("el-dropdown");
      var _component_el_header = _resolveComponent("el-header");
      var _component_el_menu = _resolveComponent("el-menu");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_aside = _resolveComponent("el-aside");
      var _component_router_view = _resolveComponent("router-view");
      var _component_el_main = _resolveComponent("el-main");
      var _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_container, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_header, {
            class: "d-flex align-items-center justify-content-between fs-12",
            style: {
              "height": "70px",
              "background-color": "#062435"
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [soundStatus.value ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                size: "20",
                onClick: turnOffSound
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(Bell))];
                }),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                size: "20",
                onClick: openSound
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(MuteNotification))];
                }),
                _: 1
              })), _hoisted_4]), _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(function () {
                  return [_createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_dropdown_item, {
                        onClick: _cache[0] || (_cache[0] = function ($event) {
                          return _unref(router).push({
                            name: 'userInfo'
                          });
                        })
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode("账号信息")];
                        }),
                        _: 1
                      }), _createVNode(_component_el_dropdown_item, {
                        onClick: logout
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode("登出")];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                default: _withCtx(function () {
                  return [_createVNode(_component_el_link, {
                    underline: false
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(userInfo).userName || '用户名'), 1)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })])];
            }),
            _: 1
          }), _createVNode(_component_el_container, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_aside, {
                width: "200px",
                style: {
                  "background-color": "#062435",
                  "height": "calc(100vh - 70px)"
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_menu, {
                        router: true,
                        uniqueOpened: true,
                        "default-active": defaultActive.value,
                        "text-color": "#fff",
                        "active-text-color": "#FFF",
                        "background-color": "#062435",
                        style: {
                          "width": "200px"
                        }
                      }, {
                        default: _withCtx(function () {
                          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, function (menu) {
                            return _openBlock(), _createBlock(MenuItem, {
                              key: menu.name,
                              menu: menu
                            }, null, 8, ["menu"]);
                          }), 128))];
                        }),
                        _: 1
                      }, 8, ["default-active"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_container, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_main, {
                    style: {
                      "background-color": "#07283B",
                      "overflow": "auto",
                      "height": "calc(100vh - 70px)"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_router_view)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })]);
    };
  }
});